<template>
  <button
    class="button notification"
    @click="clear()"
  >
    <div class="notification-infos-container">
      <Avatar
        :img-name="imgName"
        light
      />
      <div class="notification-infos">
        <!-- Nom de la personne qui émet la notif -->
        <strong class="name text-small">{{ notification.titre }}</strong>
        <!-- Objet de la notif -->
        <p
          class="info text-medium"
          v-html="notification.texte"
        />
      </div>
    </div>
    <!-- Date de la notif -->
    <span class="due-time text-small">{{ dateDifference }}</span>
  </button>
</template>

<script>
import Avatar from "../../components/avatar/Avatar.vue";

import Moment from "moment";

/**
 * Affiche les détails d'une notification.
 */
export default {
  name: "Notification",
  components: {
    Avatar,
  },
  props: {
    /**
     * Informations de la notification.
     */
    notification: {
      type: Object,
      default: null,
    },
    /**
     * Nom du fichier pour l'image d'avatar avec l'extension.
     */
    imgName: {
      type: String,
      default: null,
    },
  },
  emits: [
    /**
     * Déclenché au clic sur la notification.
     * @param {Object} - Notification ciblée.
     */
    "read",
  ],
  computed: {
    // Calcule la durée écoulée entre la date de la notification et la date du jour.
    dateDifference() {
      return new Moment(this.notification.date_creation).locale("fr").fromNow(true);
    },
  },
  methods: {
    /**
     * Redirige sur l'url de la notification si existante.
     */
    clear() {
      const { url } = this.notification;
      this.$emit("read", this.notification);
      if (url && this.$route.path !== url) {
        this.$router.push(url);
      }
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/styles/components/infos/notification.scss";
</style>
